export default __webpack_public_path__ + "static/media/7.444e9b6c.jpg";